import PropertyPreview from "../property-preview/property-preview";
import axios from "axios";
import { PropertyGetSearchResponse, PropertyInfo } from "../../../shared/types/property";
import {SERVER_URL, PROPERTY_API_PATH, DEVELOPER_API_PATH} from "../../../../global_vars";
import {PropertyFilters} from "../../../shared/types/filters";
import React, {useEffect, useState} from "react";
import "./property-list.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearch} from "@fortawesome/free-solid-svg-icons";
import {IconProp} from "@fortawesome/fontawesome-svg-core";
import {useSearchParams} from "react-router-dom";
import {DeveloperGetResponse, DeveloperInfo} from "../../../shared/types/developer";
import DOMPurify from "dompurify";

function PropertyList() {

    const [searchParams] = useSearchParams();

    const queryString = searchParams.get("filters");

    const [state, setState] = useState<PropertyInfo[]>([]);

    const [propertyFilters, setPropertyFilters] = useState<PropertyFilters>(queryString ? JSON.parse(decodeURIComponent(queryString)) :{
        name: "",
        page: 1,
        page_size: 100,
        developer_ids: []
    });

    const [developer, setDeveloper] = useState<DeveloperInfo>({
        id: -1,
        name: "",
        phone_number: "",
        description: "",
        logo_url: ""
    });

    useEffect(() => {
        if (queryString) {
            const developerID = JSON.parse(decodeURIComponent(queryString)).developer_ids[0]
            getDeveloper(developerID);
        }
    }, [queryString]);

    useEffect(() => {
        getPropertyList(propertyFilters);
    }, [propertyFilters])

    const getDeveloper = (developerID: number) => {
        axios.get<DeveloperGetResponse>(`${SERVER_URL}${DEVELOPER_API_PATH}/${developerID}`).then((resp) => {
            return resp.data;
        }).then((data) => {
            var developerInfo = data.data;
            setDeveloper(developerInfo);
        }).catch((error) => {
            console.log("Error: ", error);
        })
    };

    const getPropertyList = (propertyFilters: PropertyFilters) => {
        axios.get<PropertyGetSearchResponse>(`${SERVER_URL}${PROPERTY_API_PATH}/search`, {
            params: {
                ...propertyFilters
            },
            paramsSerializer: {
                indexes: null
            }
        }).then((resp) => {
            return resp.data;
        }).then((data) => {
            var propertyInfo = data.data;
            setState(propertyInfo);
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const searchTerm = DOMPurify.sanitize(event.target.value);
        setPropertyFilters({
            ...propertyFilters,
            name: searchTerm
        })
    }

    return (
        <div style={{paddingTop: "56px"}}>
            <div className="property-list-header">
                {/*style={{backgroundImage: "url('Samples/parallex2.jpg')"}}*/}
                <h2>DISCOVER {developer.name==="" ? "DUBAI" : developer.name.toUpperCase()}'S FINEST</h2>
                <div className="content">
                    Welcome to Luxora Dubai, your gateway to the most prestigious real estate in the heart of Dubai.
                    Whether you are seeking a modern high-rise apartment, an exclusive beachfront villa, or
                    a sophisticated penthouse, we curate a selection of elite properties tailored to your lifestyle.
                    Browse our listings to explore stunning residences, premium locations, and
                    unparalleled investment opportunities in Dubai’s most sought-after neighborhoods.
                    {/*Welcome to our Properties page. Use our intuitive search bar to filter listings by*/}
                    {/*location, price range, and property type, and quickly find the perfect property for your needs.*/}
                </div>
                <div className="search-bar">
                    <FontAwesomeIcon icon={faSearch as IconProp} className="search-icon"/>
                    <input type="text" className="search-input" placeholder="Search Properties"
                           id="name" name="name" onChange={handleChange} value={propertyFilters.name}/>
                </div>
            </div>
            <div className="property-list">
                {state.map((property, index) => (
                    <PropertyPreview key={index} id={property.id} name={property.name} bed={property.bed}
                                     bath={property.bath}
                                     area={property.area} street_address={property.street_address}
                                     county={property.county}
                                     state={property.state} country={property.country} price={property.price}
                                     status={property.status} property_images={property.property_images}/>
                ))}
            </div>
        </div>
    );
}

export default PropertyList;